module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-list-item', {
    attrs: {
      "modifier": "longdivider"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "image-thumb",
    attrs: {
      "src": _vm.image,
      "width": "88px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('section', {
    staticClass: "destination-outline"
  }, [_c('h1', {
    staticClass: "destination-outline-title"
  }, [_vm._v(_vm._s(_vm.thing.item.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.areaName))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28169dd1","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/partials/destination_outline/item.vue
// module id = 638
// module chunks = 0